import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import ServiceDetail from "@/entity/services/serviceDetail";
import {IServiceDetail, IServiceDetailListItem, ServiceDetailResponseType} from "@/entity/services/serviceDetail.types";
import { SiteServicesRequestType } from "@/form/Settings/site/services.types";
import { IServiceDetailRepository } from "./ServiceDetailRepository.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";

export class ServiceDetailRepository implements IServiceDetailRepository {
    async fetchData(data: PaginationRequestType): Promise<IServiceDetailListItem> {

        const response = await Api.get(`/service/detail/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as ServiceDetailResponseType;

        return new ServiceDetail(responseData).data[0];
    }

    async create(data: SiteServicesRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/service/detail/create', data);
        return response.data;
    }

    async update(data: FormData): Promise<ResponseDataType> {
        const response = await Api.post(`/service/detail/update`, data);
        const responseData = response.data;
        return responseData;
    }
}